export { default } from './SWPortfolioDisplayHeader';
